<template>
    <div>
        <el-table :data="items" stripe class="domain-table" :show-overflow-tooltip="false" table-layout="auto">
            <template slot="empty">
                <div v-if="loading" class="loading-body">
                    <i class="el-icon-loading"></i>
                    <span>Đang tải...</span>
                </div>
                <div v-else class="empty-body">
                    <span>Không có dữ liệu</span>
                </div>
            </template>
            <el-table-column label="Thời gian" min-width="110">
                <template slot-scope="{ row }">
                    <span>Quý {{convertToRoman(row.quarter)}}/{{row.year}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Họ tên" min-width="200">
                <template slot-scope="{ row }">
                    <span>{{row.user.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Mã NS" min-width="80">
                <template slot-scope="{ row }">
                    <span>{{row.user?.id + 100000 ?? ''}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="position" label="Vị trí" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{row.user?.profile?.account_type?.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Level hiện tại" min-width="150">
                <template slot-scope="{ row }">
                    <span>{{row.current_level.level}}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="180" label="Team">
                <template slot-scope="{ row }">
                    <span>{{row.department.name}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Điểm KRA" min-width="110">
                <template slot-scope="{ row }">
                    <el-tooltip
                        effect="light"
                        placement="top"
                        :content="'Giải thích: Tổng điểm/ điểm tối đa của tiêu chí'"
                        :class="parseInt(row.kra_score) >= 100 ? 'text-success' : 'text-danger'"
                    >
                        <span class="link">{{ parseInt(row.kra_score) ? parseInt(row.kra_score) + '/100' : '0/100'}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="Điểm họp" min-width="100">
                <template slot-scope="{row}">
                    {{ row.meeting_points ? parseInt(row.meeting_points) + '/10' : '0/10'}}
                </template>
            </el-table-column>
            <el-table-column label="Điểm EXP" min-width="100">
                <template slot-scope="{row}">
                    {{ row.exp_points ?? 0 }}
                </template>
            </el-table-column>

            <el-table-column label="Điểm trừ" min-width="100">
                <template slot-scope="{ row }">
                    <el-popover
                        v-if="row.total_minus_point > 0"
                        placement="right"
                        trigger="click"
                        width="360"
                        @show="getDetailMinusPoint(row)"
                    >
                        <div v-if="row._minusLoading" class="py-2 text-center">
                            <i class="el-icon-loading"></i> Đang tải...
                        </div>

                        <el-empty
                            v-else-if="!row.minus_point || row.minus_point.length === 0"
                            description="Không có chi tiết"
                        />

                        <el-table v-else :data="row.minus_point" border size="mini">
                            <el-table-column prop="point" label="Số điểm trừ" width="120" />
                            <el-table-column prop="description" label="Chi tiết" />
                        </el-table>
                        <span
                            slot="reference"
                            class="cursor-pointer"
                            :class="row.total_minus_point > 0 ? 'text-danger' : 'text-success'"
                        >
                                  -{{ row.total_minus_point }}
                                </span>
                    </el-popover>
                    <span v-else :class="row.total_minus_point > 0 ? 'text-danger' : 'text-success'">
                      {{ row.total_minus_point }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="Tổng điểm" min-width="120">
                <template slot-scope="{ row }">
                    <el-tooltip content="Giải thích: Tổng điểm / điểm cần đạt để tăng level" placement="top" effect="light">
                        <span style="color: #4D1EAB; font-weight: 600;">{{ calcTotal(row) }}/ {{ row.requested_level.score }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column label="Kết quả" min-width="170">
                <template slot-scope="{ row }">
                    <div class="w-100" style="font-weight: 700" :class="expectedDefineColor[row.approve_type]">
                        {{ expectedDefineText[row.approve_type] }}
                        <i style="font-weight:800" :class="expectedDefineIcon[row.approve_type]"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Level chuyên môn mới" min-width="190">
                <template slot-scope="{ row }">
                    <el-tooltip effect="light" placement="top">
                        <div v-if="getPointNeeded(row)" slot="content">
                            Mục tiêu của bạn rất gần rồi 😍<br>
                            Bạn cần đạt <b>{{ getPointNeeded(row) }}</b> điểm
                        </div>
                        <div v-else slot="content">
                                Bạn đã đủ điểm để đạt level tiếp theo 😍
                        </div>
                        <span>{{ row.requested_level?.level }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

import {
    GET_DETAIL_MINUS_POINT,
} from "@/core/services/store/progress-level/progressLevel.module";

export default {
    name: 'DomainReviewTable',
    components: {

    },
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            expectedDefineIcon: { 0:'', 1:'el-icon-top', 2:'el-icon-bottom', 3:'fas fa-square' },
            expectedDefineText: { 0:'', 1:'Tăng Level',  2:'Giảm Level', 3:'Giữ Nguyên Level' },
            expectedDefineColor:{ 0:'', 1:'text-success', 2:'text-danger', 3:'text-warning' },
        };
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = {
                1: 'I',
                2: 'II', 
                3: 'III',
                4: 'IV'
            };
            return romanNumerals[num] || num;
        },
        calcTotal(row){
            const n = v => (parseInt(v) || 0);
            const kraScore = n(row?.kra_score);
            const meetingPoints = n(row?.meeting_points);
            const expPoints = n(row?.exp_points);
            const totalMinusPoint = n(row?.total_minus_point);
            const sum = kraScore + meetingPoints + expPoints - totalMinusPoint;
            return Math.max(0, sum);
        },
        getPointNeeded(item) {
            const kra_score = item.kra_score ?? 0;
            const meeting_points = item.meeting_points ?? 0;
            const exp_points = item.exp_points ?? 0;
            const sum = parseInt(kra_score)+parseInt(meeting_points)+parseInt(exp_points)
            const denominator = parseInt(item.requested_level.score) ?? 0;

            if(denominator - sum > 0) {
                 return denominator - sum;
            }
            return 0;
        },

        getDetailMinusPoint(item){
            this.$set(item, '_minusLoading', true);
            const payload = {
                user_id: item.user_id,
                year: item.year,
                quarter: item.quarter,
            };
            this.$store.dispatch(GET_DETAIL_MINUS_POINT, payload).then(res => {
                item.minus_point = res?.data;
                this.$set(item, '_minusLoading', false);
            }).catch(e => {
                console.error(e);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/* Harmonize table style with TeamleadProgressTable */
.trend { font-weight: 600; }
.trend.up { color: #16a34a; }
.trend.hold { color: #f59e0b; }
.trend.down { color: #ef4444; }

.btn-approve-level { border-radius: 6px; color: #4D1EAB; }

/deep/ .domain-table .el-table__header th,
/deep/ .domain-table .el-table__body td,
/deep/ .domain-table .el-table__header th .cell,
/deep/ .domain-table .el-table__body td .cell {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow: visible !important;
  max-width: none !important;
  height: auto !important;
  text-align: center !important;
}

/deep/ .domain-table .el-table__header th {
  background: #4d1eab !important;
  color: #fff !important;
  border-color: #4d1eab !important;
  line-height: 1.4 !important;
  padding: 16px 8px !important;
  height: 80px !important;
}

/deep/ .domain-table .el-table__body td {
  line-height: 1.3 !important;
  padding: 8px 4px !important;
  height: auto !important;
}

/deep/ .domain-table .el-table__body tr {
  height: 80px !important;
}

/* Force keep-all to win over any inherited break-word */
/deep/ .domain-table .el-table__body td .cell,
/deep/ .domain-table .el-table__body td .cell * {
  word-break: keep-all !important;
  white-space: normal !important;
}

.loading-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #606266;

    i {
        font-size: 24px;
        margin-bottom: 10px;
        animation: rotating 2s linear infinite;
    }

    span {
        font-size: 14px;
    }
}

@keyframes rotating {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>
